import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { request } from './helper';
import { RepliesState, Reply } from '@/types'; // Import necessary types

// **Thunks**
export const repliesGet = createAsyncThunk<Reply[]>('replies/get', async () => {
  const response = await request('api/reply');
  return response.success ? response.data : [];
});

export const repliesCreate = createAsyncThunk<Reply, Partial<Reply>>(
  'replies/create',
  async (data) => {
    const response = await request('api/reply', 'POST', data);
    return response.success ? response.data : null;
  }
);

export const repliesUpdate = createAsyncThunk<Reply, { id: number; data: Partial<Reply> }>(
  'replies/update',
  async ({ id, data }) => {
    const response = await request(`api/reply/${id}`, 'PUT', data);
    return response.success ? response.data : null;
  }
);

// export const repliesDelete = createAsyncThunk<
//   number, // Return type: ID of the deleted reply
//   number, // Argument type: ID to delete
//   { rejectValue: string } // Rejected value type: custom error string
// >(
//   'replies/delete',
//   async (id, { rejectWithValue }) => {
//     try {
//       const response = await request(`api/reply/${id}`, 'DELETE');
//       if (response.success) {
//         return id; // Return the ID of the deleted reply
//       }
//       return rejectWithValue('Failed to delete reply');
//     } catch (error) {
//       return rejectWithValue('An error occurred while deleting the reply');
//     }
//   }
// );

export const repliesCreateACReply = createAsyncThunk<Reply, { id: number; data: any }>(
  'replies/acReply',
  async ({id, data}) => {
    const response = await request(`api/reply/ac-reply/${id}`, 'POST', data);
    return response.success ? response.data : [];
  }
);

// export const repliesCreateMCReply = createAsyncThunk<Reply, { id: number; data: any }>(
//   'replies/mcReply',
//   async ({id, data}) => {
//     const response = await request(`api/reply/mc-reply/${id}`, 'POST', data);
//     return response.success ? response.data : [];
//   }
// );

// export const repliesCreateGLSReply = createAsyncThunk<Reply, { id: number; data: any }>(
//   'replies/glsReply',
//   async ({id, data}) => {
//     const response = await request(`api/reply/gls-reply/${id}`, 'POST', data);
//     return response.success ? response.data : [];
//   }
// );

// **Initial State**
const initialState: RepliesState = {
  replies: [],
  status: 'idle',
  loading: false,
};

// **Slice**
export const repliesSlice = createSlice({
  name: 'replies',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Get All Replies
    builder
      .addCase(repliesGet.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(repliesGet.fulfilled, (state, { payload }) => {
        state.status = 'success';
        state.replies = payload;
      })
      .addCase(repliesGet.rejected, (state) => {
        state.status = 'failed';
      });

    // Create Reply
    builder
      .addCase(repliesCreate.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(repliesCreate.fulfilled, (state, { payload }) => {
        state.status = 'success';
        if (payload) state.replies.push(payload);
      })
      .addCase(repliesCreate.rejected, (state) => {
        state.status = 'failed';
      });

    // Update Reply
    builder
      .addCase(repliesUpdate.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(repliesUpdate.fulfilled, (state, { payload }) => {
        state.status = 'success';
        if (payload) {
          state.replies = state.replies.map((item) =>
            item.id === payload.id ? { ...item, ...payload } : item
          );
        }
      })
      .addCase(repliesUpdate.rejected, (state) => {
        state.status = 'failed';
      });

    // Delete Reply
    // builder
    //   .addCase(repliesDelete.pending, (state) => {
    //     state.status = 'loading';
    //   })
    //   .addCase(repliesDelete.fulfilled, (state, { payload }) => {
    //     state.status = 'success';
    //     if (payload) {
    //       state.replies = state.replies.filter((reply) => reply.id !== payload);
    //     }
    //   })
    //   .addCase(repliesDelete.rejected, (state) => {
    //     state.status = 'failed';
    //   });

    // create Answered Call reply
    builder
      .addCase(repliesCreateACReply.pending, (state) => {
        state.loading = true;
      })
      .addCase(repliesCreateACReply.fulfilled, (state, { payload }) => {
        state.loading = false;
      })
      .addCase(repliesCreateACReply.rejected, (state) => {
        state.loading = false;
      });
  },
});

// **Export Reducer**
export default repliesSlice.reducer;